export default "__VITE_PUBLIC_ASSET__d506f98e__"